export default class ConfirmDeclarationFailedError extends Error {
    name = 'ConfirmDeclarationFailedError';
}